<template>
	<div class="modal-container" ref="modalContainer">
		<div class="form-content-body">
			<div class="row">
				<div class="col-md-12 text-center modal-header px-5 align-items-center">
					<div class="header-container row justify-content-between w-100">
						<span class="empty-space" />

						<h3 class="text-center">Follow-up questions</h3>
						<button class="close close-btn" @click="$emit('close')">
							<img src="../../assets/images/icon-close.svg" />
						</button>
					</div>
				</div>
			</div>
      <loading-spinner v-if="isDataLoading" />
			<div class="row modal-body" v-else>
				<div class="col-12 px-4">
					<div class="mb-3">
						<div class="title required-field">
							<span>17. </span>
							<span>Please describe the type of purchase</span>
						</div>
						<div class="item select-style my-2">
							<model-list-select
								:list="supplierPurchaseTypeOptions"
								:optionValue="'value'"
								:optionText="'text'"
								v-validate="'required'"
								data-vv-validate-on="input"
								name="supplierOnboardRequestData.purchaseType"
								v-model="supplierOnboardRequestData.purchaseType"
								class="w-50"
							/>
							<span
								class="text-danger input-error-text"
								v-if="errors.has('supplierOnboardRequestData.purchaseType')"
								>This field is required</span
							>
						</div>
					</div>

					<div class="mb-3">
						<div class="title required-field mt-2 mb-3">
							<span>18. </span>
              <header-with-tooltip
                  :tooltip-text="masterAgreementTooltip"
                  :isHTML="true"
                  :show-icon="true">
                <span class="mr-1">Is there a current master agreement in place with this supplier?</span>
              </header-with-tooltip>
						</div>
            <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_OPTIONS">
              <label class="row no-gutters ml-3">
                <input
                    class="vertical-radio"
                    :key="index"
                    type="radio"
                    name="supplierOnboardRequestData.masterAgreementExists"
                    v-model="supplierOnboardRequestData.masterAgreementExists"
                    :disabled="showNotificationMessage"
                    :value="radio.value"
                    v-validate="'required'"
                > {{radio.displayText}}</label>
            </div>
						<div
							class="text-danger input-error-text"
							v-if="errors.has('supplierOnboardRequestData.masterAgreementExists')"
            >This field is required
						</div>
            <div class="notification-text" v-if="showNotificationMessage">
              This answer is selected ‘no’ because you chose a new supplier on the Supplier Information page. To correct this, please return to the Supplier Information page and select an existing supplier following the instructions on question 8 a.
            </div>
					</div>
					<div class="mb-3">
						<div class="title required-field mt-2 mb-3">
							<span>19. </span>
							<span>Will the services be completed within one year?</span>
						</div>
            <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
              <label class="row no-gutters ml-3">
                <input
                    class="vertical-radio"
                    :key="index"
                    type="radio"
                    name="supplierOnboardRequestData.deliveredWithInYear"
                    v-model="supplierOnboardRequestData.deliveredWithInYear"
                    :value="radio.value"
                    v-validate="'required'"
                > {{radio.text}}</label>
            </div>
						<div
							class="text-danger input-error-text"
							v-if="
								errors.has('supplierOnboardRequestData.deliveredWithInYear')
							"
						>
							This field is required
						</div>
					</div>

					<div class="mb-3">
						<div class="title required-field">
							<span>20. </span>
							<span
								>Will the supplier provide tax, audit, or legal services?</span
							>
						</div>
						<div class="item select-style my-2">
							<model-list-select
								:list="supplierServiceType"
								:optionValue="'value'"
								:optionText="'text'"
								v-validate="'required'"
								data-vv-validate-on="input"
								name="supplierOnboardRequestData.serviceType"
								v-model="supplierOnboardRequestData.serviceType"
								class="w-50 model-text-transform"
							/>
							<span
								class="text-danger input-error-text"
								v-if="errors.has('supplierOnboardRequestData.serviceType')"
								>This field is required</span
							>
						</div>
					</div>
				</div>
			</div>
			<div class="row btn-container justify-content-lg-end px-5" v-if="!isDataLoading" :class="showNotificationMessage ? 'pb-3':null">
				<button
					class="
						flat-btn
						gray-btn
						cancel-btn
						btn
						col-md-auto col-12
						my-md-0 my-2
					"
					@click="$emit('close')"
				>
					Cancel
				</button>
				<button
					class="
						flat-btn
						gray-btn
						cancel-btn
						btn
						col-md-auto col-12
						my-md-0 my-2
					"
					@click="saveDraft"
				>
					Save Draft
				</button>
				<button
					class="
						btn
						flat-btn
						submit-btn
						ml-md-2 ml-0
						col-md-auto col-12
						my-md-0 my-2
					"
					@click="validateInputAndSubmit()"
				>
					Next
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import CONSTANTS from "@/store/constants";
import HeaderWithTooltip from "../HeaderWithTooltip";
import { ModelListSelect } from "vue-search-select";
import supplierRequestMixin from "@/mixins/supplierRequestMixin";
import api from "@/api";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
	name: "ShortForm",
	components: {LoadingSpinner, ModelListSelect,HeaderWithTooltip },
	created() {
    if(this.supplierOnboardRequestData.supplierName
        && this.supplierOnboardRequestData.supplierName.length > 0)
      this.validateSupplier()
  },
	data() {
		return {
      masterAgreementTooltip: `Answer 'yes' only if there is an executed master agreement with the supplier that statements of work would be created under. Previous work with Autodesk does not necessary mean there is a master services agreement. Ask us on <a href=${CONSTANTS.SUPPLIER_CENTRAL_SLACK_URL} target="_blank">#adsk-supplier-central</a> if you have a question about this.`,
      isDataLoading: true,
      showNotificationMessage: false
    };
	},
	mixins: [supplierRequestMixin],
	methods: {
		...mapMutations(["setCurrentTab"]),
    /*
    * Validate the supplier entered.
    * If it is a new supplier, default the Q17 to 'No'
    * If it is an existing supplier, keep it empty and allow the user to enter via form.
    */
    async validateSupplier() {
      this.isDataLoading = true
      try {
        const resp = await api.getAutocompleteSupplier(this.supplierOnboardRequestData.supplierName, true)
        let existingSupplierSelected = resp && resp.data && resp.data.result && resp.data.result.length > 0
        if(!existingSupplierSelected) {
          this.supplierOnboardRequestData.masterAgreementExists = "No"
          this.showNotificationMessage = true
        }
        else if(!(this.isFormDraft() || this.isFormReturnedRequest() || this.isFormDuplicateRequest()))
          this.supplierOnboardRequestData.masterAgreementExists = null
      } catch {
        //silent fail and do nothing
      } finally {
        this.isDataLoading = false
      }
    },
    isFormDraft() {
      return this.$route.name === 'DraftIntakeForm'
    },
    isFormReturnedRequest() {
      return this.$route.name === 'ReturnedRequestIntakeForm'
    },
	isFormDuplicateRequest() {
	  return this.$route.name === 'DuplicateIntakeForm'
	},
		saveDraft() {
			this.$emit("close");
			this.saveSupplierOnboardRequest(true);
		},
		validateInputAndSubmit() {
			this.$validator.validateAll().then((success) => {
        if(success) {
          this.$emit("close");
          this.setCurrentTab("PreviewDetails");
        }
			});
		},
	},
	computed: {
		...mapGetters([
			"supplierOnboardRequestData",
			"supplierServiceType",
			"supplierPurchaseTypeOptions",
		]),
	},
};
</script>

<style scoped>
.modal-container {
	background-color: #fff;
	overflow-y: auto !important;
	height: 100%;
	overflow-x: hidden;
	padding-bottom: 30px;
}


.btn-container {
	margin-top: 25px;
	padding-right: 20px;
}

@media (max-width: 500px) {
	.btn-container {
		margin-top: 15px;
		padding: 0;
	}
}

@-moz-document url-prefix() {
	.btn-container {
		margin-bottom: 30px;
	}
}


.modal-container >>> .form-content-body .loading-overlay {
  position: relative;
  max-height: 400px;
}

.modal-container >>> .form-content-body .loading-overlay img {
  position: absolute;
  height: 100px !important;
}
</style>

<style scoped src="@/assets/stylesheets/vueSearchSelectOverrides.css"></style>
